import React, { useState } from 'react';

// Styles & Assets
import styles from './ImageDialog.module.css';
import { IoClose } from 'react-icons/io5';

// Components
import Modal from '../../UI/Modal/Modal';

// Other
import moment from 'moment';

// Interfaces
interface Props {
    date: string
    url: string
    className: string
}

const ImageDialog: React.FC<Props> = ({ date, url, className }) => {

    const [show, setShow] = useState(false);

    return (
        <>
            <Modal show={show} setShowModal={setShow}>
                <div className={`dialog ${styles.dialog}`}>
                    <div className={styles.bar}>
                        <h1 className={styles.date}>{moment(date).format('DD-MM-YYYY HH:mm')}</h1>
                        <button className={styles.buttonClose}><IoClose /></button>
                    </div>
                    <div className={styles.imageContainer}>
                        <img src={url} className={styles.fullImage} alt=''/>
                    </div>
                </div>
            </Modal>
            <button onClick={() => setShow(true)} className={className}>
                <img src={url} alt='' />
            </button >
        </>
    );
};

export default ImageDialog;